import { __decorate } from "tslib";
import { action, observable, runInAction } from 'mobx';
export default class PromiseQueue {
    constructor() {
        this.queueing = false;
        runInAction(() => {
            this.queue = [];
        });
    }
    get length() {
        return this.queue.length;
    }
    clear(promise) {
        if (!this.queueing) {
            const { queue } = this;
            const index = queue.indexOf(promise);
            if (index !== -1) {
                queue.splice(index, 1);
            }
        }
    }
    add(promise) {
        const { queue } = this;
        queue.push(promise);
        return promise
            .then(value => {
            this.clear(promise);
            return value;
        })
            .catch(error => {
            this.clear(promise);
            throw error;
        });
    }
    async ready() {
        this.queueing = true;
        const { queue } = this;
        if (queue.length) {
            await queue.pop();
            return this.ready();
        }
        this.queueing = false;
        return Promise.resolve();
    }
}
__decorate([
    observable
], PromiseQueue.prototype, "queue", void 0);
__decorate([
    action
], PromiseQueue.prototype, "clear", null);
__decorate([
    action
], PromiseQueue.prototype, "add", null);
__decorate([
    action
], PromiseQueue.prototype, "ready", null);
